var rowSelector = function (row) { return ".awsui-attribute-editor__row:nth-child(" + (2 * row + 1) + ")"; };
var FocusHandler = /** @class */ (function () {
    function FocusHandler(node) {
        this.node = node;
    }
    FocusHandler.prototype.focusKeyInput = function (row) {
        this.focusElement(this.node.querySelector(rowSelector(row) + " .awsui-attribute-editor__field:nth-child(1) awsui-autosuggest")
            .component);
    };
    FocusHandler.prototype.focusValueInput = function (row) {
        this.focusElement(this.node.querySelector(rowSelector(row) + " .awsui-attribute-editor__field:nth-child(2) awsui-autosuggest")
            .component);
    };
    FocusHandler.prototype.focusUndoLink = function (row) {
        this.focusElement(this.node.querySelector(rowSelector(row) + " .awsui-tag-editor-undo-button"));
    };
    FocusHandler.prototype.focusRemoveButton = function (row) {
        this.focusElement(this.node.querySelector(rowSelector(row) + " .awsui-button"));
    };
    FocusHandler.prototype.focusElement = function (element) {
        if (element) {
            element.focus();
        }
    };
    return FocusHandler;
}());
export default FocusHandler;
//# sourceMappingURL=focus-handler.js.map